export default class AttributesUtil {
    /**
     * Creates an object where keys are the attributeNames and value its title
     * @param attributeNames array of attribute names
     * @param attributesInfo array with attribute information
     */
    getAttributesTitleMap(attributeNames: string[], attributesInfo: any[]): object {
        const attributesTitleMap = {};
        attributeNames.forEach((attrName) => {
            var attr = attributesInfo.find((a) => a.name == attrName);
            attributesTitleMap[attrName] = (attr ? attr.title : attrName);
        });

        return attributesTitleMap;
    }

    /**
     * Gets numeric (INTEGER or DECIMAL) attributes
     * @param attributeNames array of attribute names to be verified
     * @param attributesInfo array with attribute information
     */
    getNumericAttributes(attributeNames: string[], attributesInfo: any[]): any[] {
        return attributeNames.filter((attrName) => {
            var attr = attributesInfo.find((a) => a.name == attrName);
            return !!(attr && (attr.attrType == 'INTEGER' || attr.attrType == 'DECIMAL'));
        });
    }

    /**
     * Gets numeric (INTEGER or DECIMAL) attributes
     * @param attributeNames array of attribute names to be verified
     * @param attributesInfo array with attribute information
     */
    isDateType(attributeName: string, attributesInfo: any[]): boolean {
        const attr = attributesInfo.find((a) => a.name === attributeName);
        const type = attr ? attr.attrType : null;

        return type && (type === "TIMESTAMP" || type === "DATE");
    }

    /**
     * 
     * @param attributeName 
     * @param attributesInfo 
     * 
     * @returns 
     */
    getAttrType = function(attributeName: string, attributesInfo: any[]): string | null {
        const attr = attributesInfo.find((a) => a.name === attributeName);
        const type = attr ? attr.attrType : null;

        return type;
    }
}
